import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import GetTablesResult from "../classes/api/result/datastructuremodule/GetTablesResult";
import TableReferenceIdAndKeyDto from "../classes/dtos/TableReferenceIdAndKeyDto";

import TableReferenceKeyDto from "../classes/dtos/TableReferenceKeyDto";
import FieldReferenceDto from "../classes/dtos/datastructuremodule/FieldReferenceDto";
import CreateTableResult from "../classes/api/result/datastructuremodule/CreateTableResult";

import GetTableFilteringCapabilitiesResult from "../classes/api/result/datastructuremodule/GetTableFilteringCapabilitiesResult";
import FilteringCapabilitiesDto from "../classes/dtos/FilteringCapabilitiesDto";

const TableApi = {

    GetTablesAsync: async function (dataSourceId: number, databaseReferenceId: number, forceUpdate: boolean): Promise<ProcessingResult<GetTablesResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Table/GetTables?DataSourceId=" + dataSourceId.toString() + "&DatabaseReferenceId=" + databaseReferenceId.toString() + "&ForceUpdate=" + forceUpdate.toString(), {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetTablesResult(data.accepted, data.status, data.lastUpdateDate, data.tables.map((e: any) => new TableReferenceIdAndKeyDto(e.id, e.key, e.name, e.type, e.readOnly, e.informativeRowCount, e.parentId))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateTableAsync: async function (databaseReferenceId: number, table: TableReferenceKeyDto, fields: FieldReferenceDto[]): Promise<ProcessingResult<CreateTableResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Table/CreateTable", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'databaseReferenceId': databaseReferenceId,
                'table': table,
                'fields': fields
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateTableResult(data.accepted, data.status, data.errorMessage));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetFilteringCapabilitiesAsync: async function (tableReferenceId: number): Promise<ProcessingResult<GetTableFilteringCapabilitiesResult>> { // TODO
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Table/GetFilteringCapabilities?TableReferenceId=" + tableReferenceId.toString(), {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetTableFilteringCapabilitiesResult(data.filteringCapabilities.map((e: any) => new FilteringCapabilitiesDto(e.id, e.label, e.key, e.type, e.operators, e.isRequired))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default TableApi;